import React, { useState } from "react";
import { JiraIssuesStyled, Link, StyledButton } from "./styled";
import { JiraWorklogs } from "./JiraWorklogs";
import { JiraAllIssues} from "./JiraAllIssues";

export const JiraIssues = () => {
  const [acceptedTasks, setAcceptedTasks] = useState(false);

  console.log(acceptedTasks);

  return (
    <JiraIssuesStyled>
      <Link to="/">Wróć do Strony Głównej</Link>

      <StyledButton onClick={() => setAcceptedTasks((prev) => !prev)}>
        {acceptedTasks
          ? "Pokaż rozliczenie miesięczne"
          : "Pokaż wszystkie zgłoszenia"}
      </StyledButton>
      {acceptedTasks ? <JiraAllIssues/> : <JiraWorklogs />}
    </JiraIssuesStyled>
  );
};
